import axios from "axios";
import { loginreq, req, reqPost } from "./axiosFun";


//审核
export const examineApi = params => {
    return req("post", "/app-yijiu-backstage/auditEducationState", params);
};
// 机构列表 
export const institionListApi = params => {
    return axios
    .get(
      `http://118.195.249.109:446/app-yijiu-backstage/getAdminEducationList?token=${localStorage.getItem("logintoken")}&contactPhone=${params.contactPhone}&contactName=${params.contactName}&page=${params.page}`,
      params
    )
    .then(res => res.data);
};
// 查看机构详情 
export const institutionalDetails = params => {
    return req("get", "/app-yijiu-backstage/getAdminEducationInfo", params);
};





// WEBPACK FOOTER //
// ./src/api/institution.js